import http from '@gp/utils/httpTS';
// import { pubgDetailSuccessDataType, ProductionMilestoneListType, VisualShowcaseType } from '@gp/types/projectDetail';

import type {
  IProjectDTO,
  IProjectDetailsFinanceTrendsParamsDTO,
  IProjectInformationDTO,
} from '@gp/types/projectDetail';
import type { IBaseResponse } from '@home/types/common';

// pipeline detail页面的列表数据接口
export const getProjectMilestones: (params: { id: string | number | null; }) => Promise<any> = (
  params,
) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/project/milestonesV2', { params });

// pipeline detail页中的游戏不同阶段的图片视频资源
export const getProjectVisualcase: (params: { id: string | number | null; }) => Promise<any> = (
  params,
) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/project/visualcaseV2', {
    params,
    formatData: (data: any) => data,
  });

// pipeline detail页中的游戏不同阶段的图片视频资源
export const getProjectSimilar: (params: { id: string | number | null; }) => Promise<any> = (
  params,
) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/project/similarV2', { params });

// pipeline detail页Game Information模块数据
export const getProjectInformation: (params: { id: string; }) => Promise<any> = (params) =>
  http({
    url: '/api/v1/globalpedia_pc/project/detail_game_info',
    method: 'get',
    params,
    rawData: true,
  });

// 根据游戏类型与ID,获取所有平台的id
export const getCombinedIdsByGameType = (params: any) =>
  http({
    url: '/api/v1/intelligence_pc/detail/combined_ids',
    method: 'post',
    data: params,
    original: true,
  });

// pipeline detail页Game Information模块数据
export const getProjectDetailHistorys: (params: { id: string; }) => Promise<any> = (params) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/project/detail_historys', { params });

// 注释这部分代码，游戏详情页 暂时移除 project updates相关模块 不需要调用这个接口拿数据了
// pipeline detail 页中Project Updates模块数据
// export const getProjectUpdatesList: (params:{project_id: string }) => Promise<pubgDetailSuccessDataType> = (params) => {
//   return http.get('/api/v1/globalpedia_pc/project/updates',{params});
// };

// pipeline detail 页面的表格信息接口
// export const getProductionMilestoneList: (params:{projectId: string }) => Promise<pubgDetailSuccessDataType> = (params) => {
//   return http.get('/api/v1/globalpedia_pc/pubg_detail/productionMilestoneList',{params});
// };
// export const getPubgDetail: (params: { projectId: string }) => Promise<pubgDetailSuccessDataType> = (params) => {
//   return http.get('/api/v1/globalpedia_pc/pubg_detail/informationDetail', { params });
// };

// // pipeline detail 页面的表格信息接口
// export const getProductionMilestoneList: (params: { projectId: string }) => Promise<ProductionMilestoneListType[]> = (params) => {
//   return http.get('/api/v1/globalpedia_pc/pubg_detail/productionMilestoneList', {
//     params, formatData: (data) => {
//       if (!Array.isArray(data)) return data;
//       data.forEach((item) => {
//         const { children } = item;
//         if (children && children.length) {
//           children.forEach((item2: any) => {
//             // 给children中的每条数据添加is_children标识
//             item2.is_children = true;
//           });
//         }
//       });
//       return data;
//     },
//   });
// };

// // pipeline detail 页面的Visual Showcase模块接口
// export const getVisualShowcase: (params: { projectId: string }) => Promise<VisualShowcaseType> = (params) => {
//   return http.get('/api/v1/globalpedia_pc/pubg_detail/visualShowcase', { params });
// };

// pipeline detail 页或add new product页中simliar games对话框搜索接口，同情报首页搜索接口
export const getHomePageSearchList = (params: {
  system_type: 'pc' | (string & {});
  entity_type: 'all' | 'mobile' | 'pc' | 'console' | (string & {});
  ids: string[];
  keyword: string;
  page: number;
  page_size: number;
}) => (http as any).post('/api/v1/homepage/pc/searchNewList', params);

// 上传腾讯云获取账号信息
/* export const getUploadCloudMessage = () => {
  return http.get('/api/v1/globalpedia_pc/tencent_qcloud/bucket_region');
}; */

export const getVideoCover = (params: any) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/snapshot', { params });

// 编辑Production Milestone的日期
export const updateMilestoneDateHistory = (params: any) =>
  http({
    url: '/api/v1/globalpedia_pc/project/add_milestone_history',
    method: 'post',
    data: params,
    original: true,
  });

// pipeline detail 页Game Overview中Editable Staff模糊查询
export const getEditableStaffSearchList = (params: any) =>
  // @ts-ignore
  http.get('/api/v1/globalpedia_pc/project/edit/condList', { params });

// pipeline detail 页Project Review催办
export const goToRemind = (params: { id: number[]; type: 1 | 2; }) =>
  http({
    url: '/api/v1/globalpedia_pc/pr/remind',
    method: 'post',
    data: params,
    original: true,
  });

// 详情页milestone附件下载
export const milestoneMaterialDownLoad = (params: { path: string; }) =>
  // @ts-ignore
  http({
    url: '/api/v1/globalpedia_pc/project/milestones/material/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
    timeout: 24 * 60 * 60 * 1000, // 一天，限制的请求允许持续时间
    maxContentLength: 100 * 1024 * 1024 * 1024, // 100G，限制的请求允许响应最大资源大小
  });

// 详情页milestone列表下载
export const milestoneListDownLoad = (params: { id: string; }) =>
  // @ts-ignore
  http({
    url: '/api/v1/globalpedia_pc/project/milestones/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });

// 更新Project的Current Milestone、Next Milestone
export const updateProjectKeyMilestones = (params: {
  project_id: string;
  studio_entity_id: string;
  current_milestone: string;
  next_milestone_id: string;
  next_milestone: string;
  next_milestone_date: string;
}) =>
  http({
    url: '/api/v1/globalpedia_pc/project/next_milestone_edit',
    method: 'post',
    data: params,
    rawData: true,
  });

// 编辑Project（project_id传空字符串即为新增Project）
export const updateProjectInformation = (params: IProjectInformationDTO): IBaseResponse<string> =>
  http({
    url: '/api/v1/globalpedia_pc/project/info_edit',
    method: 'post',
    data: params,
    rawData: true,
    ignoreCode: true,
    errorHandler: true,
  }) as any;

// 编辑Game Pillar
export const updateGamePillar = (params: IProjectInformationDTO): IBaseResponse<string> =>
  http({
    url: '/api/v1/globalpedia_pc/project/game_pillar_edit',
    method: 'post',
    data: params,
    rawData: true,
    ignoreCode: true,
    errorHandler: true,
  }) as any;

// 编辑ElevatorPitch
export const updateElevatorPitch = (params: IProjectInformationDTO): IBaseResponse<string> =>
  http({
    url: '/api/v1/globalpedia_pc/project/elevator_pitch_edit',
    method: 'post',
    data: params,
    rawData: true,
    ignoreCode: true,
    errorHandler: true,
  }) as any;

// 获取Game Pillar
export const getGamePillar = (params: {
  project_id: string;
}): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/project/game_pillar',
    method: 'get',
    params,
    rawData: true,
  }) as any;

// 获取ElevatorPitch
export const getElevatorPitch = (params: {
  project_id: string;
}): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/project/elevator_pitch',
    method: 'get',
    params,
    rawData: true,
  }) as any;

// 获取StudiosOptionsData
export const getStudiosOptionsData = (): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/pipeline/studios_add',
    method: 'get',
    rawData: true,
  }) as any;

export const fetchDevCostTrends = (
  params: IProjectDetailsFinanceTrendsParamsDTO,
): IBaseResponse<any> =>
  http({
    url: '/api/v1/globalpedia_pc/finance/budget_trend',
    method: 'post',
    data: params,
    rawData: false,
  }) as any;

export const fetchHeadcountTrends = (
  params: IProjectDetailsFinanceTrendsParamsDTO,
): IBaseResponse<any> =>
  http({
    url: '/api/v1/globalpedia_pc/finance/headcount_trend',
    method: 'post',
    data: params,
    rawData: false,
  }) as any;

export const fetchDevCostHeadcountTrendsByMilestone = (params: {
  type: '1' | '2' | (string & {});
  project_id: string;
  studio_id: string;
}) =>
  http({
    url: '/api/v1/globalpedia_pc/finance/trend_by_milestone',
    method: 'post',
    data: params,
    rawData: false,
  }) as any;

/**
 * 获取可切换的Projects数据
 * @param params 参数对象
 * @param params.search 搜索关键字
 * @return 关键字匹配的可切换的Projects数据
 */
export const fetchProjects = (params: { search: string; }): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/project/detail_project',
    method: 'get',
    params,
    rawData: true,
  }) as any;

// 收藏项目
export const fetchAddProjectFollow = (params: any) =>
  http({
    url: '/api/v1/globalpedia_pc/collection/add',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;

// 检查收藏状态
export const getProjectFollowStatus = (params: { project_id: string; type: number; }): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/collection/check',
    method: 'get',
    params,
    rawData: true,
  }) as any;

// 取消收藏项目
export const cancelProjectFollow = (params: any) =>
  http({
    url: '/api/v1/globalpedia_pc/collection/delete',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;

// 获取收藏项目列表
export const getProjectFollowList = (params: { type: number; }): IBaseResponse<IProjectDTO[] | null> =>
  http({
    url: '/api/v1/globalpedia_pc/collection/list',
    method: 'get',
    params,
    rawData: true,
  }) as any;


// 收藏项目排序
export const sortProjectFollow = (params: any) =>
  http({
    url: '/api/v1/globalpedia_pc/collection/update_order',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
